// extracted by mini-css-extract-plugin
module.exports = {"container":"loadingView_container__2RwRZ","blurredBackground":"loadingView_blurredBackground__1OwdB"};